import { isValidUrl as r } from "@waitroom/utils";
const i = {
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/",
  twitter: "https://twitter.com/",
  linkedin: "https://www.linkedin.com/in/",
  tiktok: "https://www.tiktok.com/@",
  youtube: "https://www.youtube.com/c/",
  website: "//"
}, w = (t, o) => e(i[t], o), e = (t, o) => !t || !o || r(o) ? o || t : `${t}${o.trim().replace(/^@/, "")}`, n = (t) => !t || !t.length ? t : t.map((o) => ({
  ...o,
  url: w(o.platform, o.url)
}));
export {
  w as buildSocialProfileLink,
  n as buildSocialUrls,
  e as getProfileUrl,
  i as socialProfileUrls
};
